import { useEffect } from 'react'

import { CAT_FUNCTIONALITY } from '@/config/cookieConsent'
import { HELP_SCOUT_BEACON_ID } from '@/config/system'

type HelpScoutChatBubbleProps = {
  disabled?: boolean
  beaconId?: string
}

export const HelpScoutChatBubble = ({
  disabled,
  beaconId = HELP_SCOUT_BEACON_ID,
}: HelpScoutChatBubbleProps) => {
  useEffect(() => {
    if (disabled || typeof window === 'undefined') {
      return
    }

    const existingScripts = document.querySelectorAll(
      `script[data-category="${CAT_FUNCTIONALITY}"][id^="helpscout-"]`
    )

    if (existingScripts.length > 0) {
      return
    }

    const script1 = document.createElement('script')
    script1.id = 'helpscout-loader'
    script1.type = 'text/plain' // Initially block the script from running, our consent management will allow it to run once consent is given
    script1.setAttribute('data-category', CAT_FUNCTIONALITY)
    script1.innerHTML = `
      !(function (e, t, n) {
        function a() {
          var e = t.getElementsByTagName("script")[0],
            n = t.createElement("script");
          (n.type = "text/javascript"),
            (n.async = !0),
            (n.src = "https://beacon-v2.helpscout.net"),
            e.parentNode.insertBefore(n, e);
        }
        if (
          ((e.Beacon = n =
            function (t, n, a) {
              e.Beacon.readyQueue.push({ method: t, options: n, data: a });
            }),
          (n.readyQueue = []),
          "complete" === t.readyState)
        )
          return a();
        e.attachEvent
          ? e.attachEvent("onload", a)
          : e.addEventListener("load", a, !1);
      })(window, document, window.Beacon || function () {});
    `

    const script2 = document.createElement('script')
    script2.id = 'helpscout-init'
    script2.type = 'text/plain'
    script2.setAttribute('data-category', CAT_FUNCTIONALITY)
    script2.innerHTML = `
      window.Beacon('init', '${beaconId}')
    `

    const script3 = document.createElement('script')
    script3.id = 'helpscout-config'
    script3.type = 'text/plain'
    script3.setAttribute('data-category', CAT_FUNCTIONALITY)
    script3.innerHTML = `
      window.Beacon('config', {
        display: {
          zIndex: 50
        },
      });
    `

    document.head.appendChild(script1)
    document.head.appendChild(script2)
    document.head.appendChild(script3)
  }, [disabled, beaconId])

  return null
}
